<template>
  <div class="usecase-box clearfix">
    <div class="usecase-title">用例{{index}}：</div>
    <div class="usecase">
      <textarea v-model="fusecase"></textarea>
    </div>
    <div class="usecase-result">
      <textarea v-model="fusecaseResult" ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "usecaseBar",
  props:{
    index: Number,
    usecase: String,
    usecaseResult: String
  },
  computed:{
    fusecase:{
      get:function(){
        return this.usecase
      },
      set:function(newValue){
        this.$emit("event-usecase", this.index, newValue);
      }
    },
    fusecaseResult:{
      get:function(){
        return this.usecaseResult
      },
      set:function(newValue){
        this.$emit("event-usecase-result", this.index, newValue);
      }
    }
  },

  methods:{

  }
}
</script>

<style scoped>
.usecase-box{
  height: 70px;
  box-sizing: border-box;
  padding-left: 10px;
}
.usecase-title{
  float: left;
  line-height: 50px;
  width: 80px;
  text-align: right;
}
.usecase{
  float: left;
  width: 300px;
}
.usecase textarea{
  width:  250px;
  height: 50px;
}
.usecase-result{
  margin-left: 300px;
}
.usecase-result textarea{
  width:  250px;
  height: 50px;
}

</style>
